import { render } from "./ReconciliationStep3-2.vue?vue&type=template&id=20dd6364"
import script from "./ReconciliationStep3-2.vue?vue&type=script&lang=js"
export * from "./ReconciliationStep3-2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__